import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import config from '../../../../../../../config';

export default function VersionIndicator() {
  const { t } = useTranslation();

  return (
    <Typography className="version">
      {t('menu.version', { version: config.AppVersion })}
    </Typography>
  );
}
